// Modules
import { Pagination, A11y, Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Styles
import Styles from "./Styles/Slider.module.css";
// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Slider = ({
  Card,
  itemsPerView,
  slidesClass,
  vertical,
  noPagination,
  space,
  arrow,
  data,
  error,
  kind,
  handleChangePosts,
  handleShareArticle,
  handleSaveArticle,
  landing,
  reservedIcons,
}) => {
  //   {
  //     id: 1,
  //     bookName: "موفقیت نامحدود در ۲۰ روز",
  //     writerName: "آنتونیو رابینز",
  //     translatorName: "فریبا جعفری",
  //     description:
  //       "این کتاب نوشته ی آنتونیو رابینز با ترجمه ی فریبا جعفری شما ر در جهت رسیدن به موفقیت های نامحدود در ۲۰ روز راهنمایی میکند",
  //     image: item1,
  //   },
  //
  return (
    <>
      {data.length === 0 ? (
        <div
          className={`${Styles.emptyContainer} ${
            Styles["empty" + slidesClass]
          } ${landing ? Styles.pcSizeEmptyContainer : {}}`}
        >
          {error}
        </div>
      ) : (
        <Swiper
          direction={vertical ? "vertical" : "horizontal"}
          modules={[Pagination, A11y, Autoplay, Navigation]}
          spaceBetween={space ? space : 5}
          grabCursor={true}
          navigation={arrow ? { enabled: true } : undefined}
          slidesPerView={itemsPerView}
          pagination={noPagination ? false : { clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          className={`${Styles.container} ${
            slidesClass === "journalSlideContainer"
              ? Styles.journalContainer
              : slidesClass === "visualSlideContainer"
              ? Styles.visualContainer
              : {}
          } ${landing ? Styles.pcSizeContainer : {}}`}
        >
          {data?.map((item, index) => (
            <SwiperSlide key={index} className={Styles[slidesClass]}>
              <Card
                item={item}
                kind={kind}
                handleChangePosts={handleChangePosts}
                handleShareArticle={handleShareArticle}
                handleSaveArticle={handleSaveArticle}
                reservedIcons={reservedIcons}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
};

export default Slider;
